// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"350":"21310fd4","875":"3a5e5ead"}[chunkId] + ".chunk.js";
};